export default __webpack_public_path__ + "static/media/timesheet.0e76caca.png";